/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationSettingsType } from './SimulationSettingsType';
import {
    SimulationSettingsTypeFromJSON,
    SimulationSettingsTypeFromJSONTyped,
    SimulationSettingsTypeToJSON,
    SimulationSettingsTypeToJSONTyped,
} from './SimulationSettingsType';

/**
 * 
 * @export
 * @interface SimulationSettingMapping
 */
export interface SimulationSettingMapping {
    /**
     * 
     * @type {SimulationSettingsType}
     * @memberof SimulationSettingMapping
     */
    type: SimulationSettingsType;
    /**
     * 
     * @type {string}
     * @memberof SimulationSettingMapping
     */
    target: string | null;
}



/**
 * Check if a given object implements the SimulationSettingMapping interface.
 */
export function instanceOfSimulationSettingMapping(value: object): value is SimulationSettingMapping {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function SimulationSettingMappingFromJSON(json: any): SimulationSettingMapping {
    return SimulationSettingMappingFromJSONTyped(json, false);
}

export function SimulationSettingMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationSettingMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'type': SimulationSettingsTypeFromJSON(json['type']),
        'target': json['target'],
    };
}

export function SimulationSettingMappingToJSON(json: any): SimulationSettingMapping {
    return SimulationSettingMappingToJSONTyped(json, false);
}

export function SimulationSettingMappingToJSONTyped(value?: SimulationSettingMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': SimulationSettingsTypeToJSON(value['type']),
        'target': value['target'],
    };
}

